/* src/app/private/components/user/delete-user/delete-user.component.scss */
/*# sourceMappingURL=delete-user.component.css.map */
